export const environment = {
  production: false,
  apiUrl: 'https://homolog.api.digital.itcnet.com.br',
  keycloak: {
    authority: 'https://homolog.keycloak.itcnet.com.br',
    redirectUri: 'https://homolog.digital.itcnet.com.br/servicos',
    postLogoutRedirectUri: 'https://homolog.digital.itcnet.com.br/inicio',
    realm: 'itcnet',
    clientId: 'itc_digital_clientid',
  },
  idleConfig: { idle: 10, timeout: 60, ping: 10 },
};